import { saludService } from '../services';

// Disponibilidad del backend. Mientras disponible sea false, App.vue tapa el
// sistema con el aviso de fuera de servicio.
export const servicio = {
    namespaced: true,
    state: {
        disponible: true,
    },
    actions: {
        // Varias peticiones fallidas a la vez comparten una sola consulta.
        verificar({ commit }) {
            if (!verificacionEnCurso) {
                verificacionEnCurso = saludService.backendDisponible()
                    .then(disponible => {
                        commit('disponibilidad', disponible);
                        return disponible;
                    })
                    .finally(() => { verificacionEnCurso = null; });
            }
            return verificacionEnCurso;
        },
    },
    mutations: {
        disponibilidad(state, disponible) {
            state.disponible = disponible;
        },
    },
};

let verificacionEnCurso = null;
